export default "__VITE_ASSET__5350d2f0__"